var moduleMap = {
	"./componentsIndex": () => {
		return Promise.all([__webpack_require__.e(311), __webpack_require__.e(641), __webpack_require__.e(976), __webpack_require__.e(163), __webpack_require__.e(501), __webpack_require__.e(986), __webpack_require__.e(608), __webpack_require__.e(233)]).then(() => (() => ((__webpack_require__(6233)))));
	},
	"./containerStore": () => {
		return Promise.all([__webpack_require__.e(976), __webpack_require__.e(837)]).then(() => (() => ((__webpack_require__(7837)))));
	},
	"./biStore": () => {
		return Promise.all([__webpack_require__.e(976), __webpack_require__.e(687)]).then(() => (() => ((__webpack_require__(6687)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});